
import React from 'react'
import { logo } from '../../public/LoginImages/importimages'
import { Form, Link } from 'react-router-dom'
import './homepage.css'
const Navbar = () => {

  function onSubmitHandler() {
    alert("This page is under maintaince")
  }
  return (
    <nav className="navbar navbar-expand-lg" style={{ backgroundColor: 'white', zIndex: "15" }}>
      <div className="container-fluid">
        {/* <img src={logo} alt='logo' style={{ height: '3rem', width: '3rem' }} ></img> */}
        <Link className="navbar-brand" to="/">Vadhavan</Link>
        <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
          <span className="navbar-toggler-icon"></span>
        </button>
        <div className="collapse navbar-collapse" id="navbarSupportedContent">
          <ul className="navbar-nav me-auto mb-2 mb-lg-0">
            {/* <li className="nav-item">
              <a className="nav-link active" aria-current="page" href="/Dashboard/RegistrationForm">Registrations</a>
            </li> */}
            {/* <li className="nav-item">
              <a className="nav-link active" aria-current="page" href="/Dashboard/Reciept">Reciept</a>
            </li> */}

            <li className="nav-item dropdown">
              <a className="nav-link dropdown-toggle" href="#" role="button" data-bs-toggle="dropdown" aria-expanded="false">
                Menu
              </a>
              <ul className="dropdown-menu">
                <li><a className="dropdown-item" href='/Dashboard/contactUs' >Contact Us</a></li>
                <li><a className="dropdown-item" href='/Dashboard/AboutUs'>About Us</a></li>
                <li><hr className="dropdown-divider" /></li>
                <li><a className="dropdown-item" onClick={onSubmitHandler}>Suggestions</a></li>
              </ul>
            </li>

          </ul>
          <Form className="d-flex" role="search">
            <input className="form-control me-2" hidden type="search" placeholder="Search" aria-label="Search" />
            <button className="btn btn-success" hidden type="submit">Search</button>
          </Form>
        </div>
      </div>
    </nav>
  )
}

export default Navbar